<template>
  <div class="content-main page-community-rules">
    <div class="rule" v-for="(rule, i) in rules" :key="i+10">
      <div class="first">{{rule.first}}</div>
      <div class="second" v-for="(second, j) in rule.seconds" :key="j + 100">
        <div class="title">{{second.title}}</div>
        <div class="third flex-box" v-for="(third, k) in second.thirds" :key="k + 1000">
          <span>•&nbsp;&nbsp;&nbsp;</span><span>{{third}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  data(){
    return {
      rules: [
        {
          "first": "欢迎您使用3天CP服务（下称：本服务），您在使用本服务前请认真阅读以下协议（下称：本协议）。"
        },
        {
          "first": "一. 本协议的适用",
          "seconds": [
            {"title": "当您使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，与运营方达成协议。"},
          ]
        },
        {
          "first": "二. 本协议的变更和修改",
          "seconds": [
            {
              "title": "运营方有权随时对本协议进行修改，并且一旦发生协议条款的变动，运营方将在相关页面上提示修改的内容；用户如果不同意本协议的修改，可以放弃使用或取消已经获得的服务；如果用户选择在本协议变更后继续使用本服务，则视为用户已经接受本协议的修改。",
            }
          ]
        },
        {
          "first": "三. 用户行为",
          "seconds": [
            { "title": "1. 用户需年满18周岁，方可使用本服务。如发现用户未年满18周岁，运营方有权停止该用户使用资格。"},
            { "title": "2. 用户必须承诺遵守并维护法律法规、国家利益、公共秩序、社会道德风尚和信息真实性等底线。"},
            {
              "title": "3. 用户不得出现以下行为：",
              "thirds": [
                "反对宪法所确定的基本原则", "危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一", "损害国家荣誉和利益",
                "煽动民族仇恨、民族歧视，破坏民族团结", "侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的", "破坏国家宗教政策，宣扬邪教和封建迷信",
                "散布谣言，扰乱社会秩序，破坏社会稳定", "宣扬淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪", "煽动非法集会、结社、游行、示威、聚众扰乱社会秩序",
                "诽谤他人，泄露他人隐私，侵害他人合法权益", "含有法律、行政法规禁止的其他内容的信息"
              ]
            },
            { "title": "4. 用户须对使用本服务过程中发表的内容承担全部责任。"},
          ]
        },
        {
          "first": "四. 免责声明",
          "seconds": [
            {"title": "1. 运营方不能对用户提供的信息或发表内容的真实性进行保证。"},
            {"title": "2. 用户发表的内容仅代表用户自身观点，并不反映运营方的意见及观点。"}
          ]
        }
      ]
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    }
  },
  mounted(){

  }
}

</script>

<style scoped>
html{
  overflow-x:auto;
  overflow-y:auto;
}
body{
  overflow-x:auto;
  overflow-y:auto;
}
.content-main{
  text-align:left;
  color:#222;
  background-color:#fff;
  min-height:100%;
  padding:20px 10px;
}
.rule{margin-bottom:20px;}
.rule .first{font-size:32px;font-weight:bold;margin-bottom:10px;}
.rule .second{padding:0px 10px;}
.rule .second .title{font-size:30px;margin-bottom:3px;margin-top:5px;}
.rule .third{font-size:28px;padding:0px 10px;margin-bottom:2px;align-items:flex-start;}
</style>
